module.exports = __webpack_public_path__ + "static/img/image_tag_point_exchange.c6869e5.png";